import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-github-icon',
  templateUrl: './code-github.component.html'
})
export class CodeGithubComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
